import { User } from 'app/models/Users';
import { ServerResponse } from './../../models/ServerResponse';
import { Component, ViewChild, ElementRef, Input } from '@angular/core';
import { SplendidCRMDFService } from 'app/services/SplendidCRMDFService';

@Component({
  selector: 'app-sidebar-header',
  templateUrl: './app-sidebar-header.component.html',
  styleUrls: ['./app-sidebar-header.component.scss'],
})
export class AppSidebarHeaderComponent { 
  @Input() isMinimizado;
  userProfile:User;
  fullName;

  subcription;

  constructor(
    private splendidService: SplendidCRMDFService
  ) {
    this.subcription = this.splendidService.getUserProfile().subscribe(userProfile =>{
      this.userProfile = userProfile;
    });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subcription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/components/app-sidebar-header/app-sidebar-header.component.ts